import { render, staticRenderFns } from "./shipping-quote-status-chip.vue?vue&type=template&id=cdd66ac4&scoped=true&lang=pug&"
import script from "./shipping-quote-status-chip.vue?vue&type=script&lang=ts&"
export * from "./shipping-quote-status-chip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdd66ac4",
  null
  
)

export default component.exports